import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const GoogleIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-label="Google">
    <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z" />
    <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z" />
    <path fill="#FBBC05" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24s.85 6.91 2.34 9.88l7.35-5.7z" />
    <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z" />
  </svg>
);

const Star = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="#fbbc04" aria-hidden="true">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);

const Stars = () => (
  <div className="vjr-review-stars" aria-label="5 estrelas">
    {[0, 1, 2, 3, 4].map((n) => <Star key={`star-${n}`} />)}
  </div>
);

export const ReviewsSection = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Fetch reviews once on mount. API and axios are module-level imports;
    // no deps needed for this fire-and-forget effect.
    axios.get(`${API}/reviews`)
      .then((res) => setData(res.data))
      .catch(() => setData(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data || !data.reviews || data.reviews.length === 0) return null;

  return (
    <section className="vjr-reviews-section" id="testemunhos" data-testid="reviews-section">
      <div className="vjr-reviews-inner">
        <div className="vjr-reviews-header">
          <div>
            <div className="valuare-section-label valuare-label-light">Testemunhos</div>
            <h2 className="valuare-section-title valuare-title-light" style={{ marginBottom: 0 }}>
              A Confiança dos<br />Nossos <em>Clientes</em>
            </h2>
          </div>
          <div className="vjr-reviews-summary" data-testid="reviews-summary">
            <div className="vjr-reviews-rating">{Number(data.rating).toFixed(1).replace('.', ',')}</div>
            <Stars />
            <div className="vjr-reviews-count">
              {data.total} {data.total === 1 ? 'avaliação' : 'avaliações'} no Google
            </div>
            {data.mapsUrl && (
              <a
                href={data.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="vjr-reviews-link"
                data-testid="reviews-google-link"
              >
                <GoogleIcon size={14} /> Ver no Google
              </a>
            )}
          </div>
        </div>
        <div className="vjr-reviews-marquee" data-testid="reviews-marquee">
          <div
            className="vjr-reviews-track"
            style={{ animationDuration: `${Math.max(data.reviews.length * 14, 40)}s` }}
          >
            {[...data.reviews, ...data.reviews].map((review, index) => {
              const reviewKey = `${review.author || 'anon'}-${index}`;
              return (
                <article
                  key={reviewKey}
                  className="vjr-review-card"
                  aria-hidden={index >= data.reviews.length}
                  data-testid={`review-card-${index}`}
                >
                  <Stars />
                  <p className="vjr-review-text">&ldquo;{review.text}&rdquo;</p>
                  {data.mapsUrl && (
                    <a
                      href={data.mapsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="vjr-review-more"
                      tabIndex={index >= data.reviews.length ? -1 : 0}
                    >
                      Ler mais
                    </a>
                  )}
                  <div className="vjr-review-author">
                    {review.photo && (
                      <img src={review.photo} alt={review.author} className="vjr-review-avatar" loading="lazy" referrerPolicy="no-referrer" />
                    )}
                    <div>
                      <div className="vjr-review-name">{review.author}</div>
                      <div className="vjr-review-time">{review.relativeTime}</div>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
